import { defineMessages } from 'react-intl';

export default defineMessages({
    policylandingCategory: {
        id: 'e1p.gateway.views.policy-landing.Category',
        defaultMessage: 'Category',
    },
    policylandingPolicyLine: {
        id: 'e1p.gateway.views.policy-landing.Policy Line',
        defaultMessage: 'Product',
    }
});
